import * as _ from "lodash";
import { EventTypeBO } from "./EventTypeBO";
import { MessageType } from "../PA.Core/PA.Core.IF.Basic";

export class EventTypeBOValidations {
    static async ValidateEmptyFields(aBO: EventTypeBO): Promise<void> {
        // Validate Event Type Id
        if (_.isEmpty(aBO.WB_EventType.cif.TYPE_ID)) {
            aBO.ValidateMessageProvider.addMessage({
                type: MessageType.Error,
                code: "EmptyId",
                title: "Event Type ID cannot be empty",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("EmptyId");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.TYPE_NAME)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "EmptyName",
                type: MessageType.Error,
                title: "Event Type Name cannot be empty",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("EmptyName");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.SOURCE_ID)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "EmptyName",
                type: MessageType.Error,
                title: "Source ID cannot be empty",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("EmptyName");
        }
        let datesDiffer = false;
        let bEmptyStartDate = false;
        let bEmptyEndDate = false;

        _.forEach(aBO.WB_EventType.WB_EventSpendTypeRows, function (aRow) {
            if (aRow.cif.EFFECTIVE_START_DT === "") {
                bEmptyStartDate = true;
            }

            if (aRow.cif.EFFECTIVE_END_DT === "") {
                bEmptyEndDate = true;
            }

            if (_.isDate(aRow.EffectiveStartDt) && _.isDate(aRow.EffectiveEndDt)) {
                if (aRow.EffectiveEndDt < aRow.EffectiveStartDt) {
                    datesDiffer = true;
                }
            }
        });

        if (bEmptyStartDate) {
            // Log Message
            aBO.ValidateMessageProvider.addMessage({
                code: "EmptyStartDate",
                type: MessageType.Error,
                title: "Start Date cannot be empty",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("EmptyStartDate");
        }

        if (bEmptyEndDate) {
            // Log Message
            aBO.ValidateMessageProvider.addMessage({
                code: "EmptyEndDate",
                type: MessageType.Error,
                title: "End Date cannot be empty",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("EmptyEndDate");
        }

        if (datesDiffer) {
            // Log Message
            aBO.ValidateMessageProvider.addMessage({
                code: "datesDiffer",
                type: MessageType.Error,
                title: "Effective start date must be before the effective end date",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("datesDiffer");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.COVERAGEFACTOR_LEVEL)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "bCoverageFactorLevel",
                type: MessageType.Error,
                title: "Empty coverage level cannot be empty ",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("bCoverageFactorLevel");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.MERCH_ACV_LEVEL)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "merchacvlevel",
                type: MessageType.Error,
                title: "Merch ACV Level cannot be empty ",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("merchacvlevel");
        }
        if (_.isEmpty(aBO.WB_EventType.cif.INSTOREDATES_POLICY)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "instoredatespolicy",
                type: MessageType.Error,
                title: "InStore Dates Need to select ",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("instoredatespolicy");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.SHIPMENTDATES_POLICY)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "shipmentdatespolicy",
                type: MessageType.Error,
                title: "Shipment Dates Policy cannot be empty ",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("shipmentdatespolicy");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.DISTRIBUTIONDATES_POLICY)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "distributiondatespolicy",
                type: MessageType.Error,
                title: "Distritbution Dates Policy cannot be empty ",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("distributiondatespolicy");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.ORDERDATES_POLICY)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "orderdatespolicy",
                type: MessageType.Error,
                title: "Order Dates Policy cannot be empty ",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("orderdatespolicy");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.WORKFLOW_POLICY)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "orderdatespolicy",
                type: MessageType.Error,
                title: "Work Flow Policy cannot be empty ",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("orderdatespolicy");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.COPY_POLICY)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "copypolicy",
                type: MessageType.Error,
                title: "Copy Policy cannot be empty ",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("copypolicy");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.STANDARDCALCULATORCLASS)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "standardcalculatorclass",
                type: MessageType.Error,
                title: "Standard Calculator Class cannot be empty ",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("standardcalculatorclass");
        }

        if (_.isEmpty(aBO.WB_EventType.cif.EVENTCALCULATORCLASS)) {
            aBO.ValidateMessageProvider.addMessage({
                code: "eventcalculatorclass",
                type: MessageType.Error,
                title: "Event Calculator Class cannot be empty ",
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("eventcalculatorclass");
        }
        const overlappingStatuses = (aBO.WB_EventType.OverlapErrorStatuses ?? []).filter((errStat) =>
            (aBO.WB_EventType.OverlapWarningStatuses ?? []).includes(errStat),
        );
        if (overlappingStatuses.length > 0) {
            aBO.ValidateMessageProvider.addMessage({
                code: "overlapstatuses",
                type: MessageType.Warning,
                title: `The following event status types are in both the Overlap Warning and Error lists, and any overlapping events with the status types will be treated as errors: ${overlappingStatuses.join(", ")} `,
                description: "",
                subtitle: "",
                count: 0,
            });
        } else {
            aBO.ValidateMessageProvider.removeMessage("overlapstatuses");
        }
    }
}
